<template>
    <div class="home">
        <timeline db="tasks" sortimenter="users" property="manager" ref="timeline" :methods="{ getColor }" :defaultduration="432000"/>
    </div>
</template>

<script>
import timeline from "@/timeline-components/timeline.vue";

export default {
    name: "Tasks",
    route: { path: "/taskstimeline", icon: "mdi-treasure-chest", toolbar: true, sidebar: true, homepage: true, usecase: "taskstimeline", open: "/taskstimeline" },
    components: { timeline },
    mounted() {
        this.$refs.timeline.update();
    },
    methods: {
        getColor(e) {
            let color = this.$vuetify.theme.themes.light.primary;
            if (e.active) return color + "99";
            return "#77777777";
        },
    },
    watch: {
        "$store.state.database.tasks": function (newVal, oldVal) {
            this.$refs.timeline.update();
        },
        "$store.state.database.locations": function (newVal, oldVal) {
            this.$refs.timeline.update();
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#home {
}
</style>
